import React from 'react';
import { CTAButton } from './CTAButton';
const results = [{
  label: 'TIENDA 1',
  amount: '$47.000.000',
  image: 'https://cdn.magicpatterns.com/uploads/8iQb4yV17KvLsVexiE4yF4/TIENDA_1.jpg'
}, {
  label: 'TIENDA 2',
  amount: '$21.000.000',
  image: 'https://cdn.magicpatterns.com/uploads/e5774hAGZz8777oghUPigq/TIENDA_2.jpg'
}, {
  label: 'TIENDA 3',
  amount: '$42.140.000',
  image: 'https://cdn.magicpatterns.com/uploads/ttY5TSkg5grcyCbbsyQbQJ/TIENDA_3.png'
}];
export function RealResultsSection() {
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-gray-900 py-16 md:py-24 px-4" data-id="element-266">
      <div className="max-w-6xl mx-auto" data-id="element-267">
        <div className="text-center mb-12" data-id="element-268">
          <div className="inline-block bg-green-500 text-white px-8 py-3 rounded-full font-black text-xl mb-6" data-id="element-269">
            📊 RESULTADOS REALES
          </div>
          <h2 className="text-4xl md:text-5xl font-black text-white mb-4" data-id="element-270">
            Mirá lo que facturan nuestras tiendas
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto" data-id="element-271">
            Estos son datos reales de tiendas Shopify usando el mismo sistema
            que vas a aprender.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-12" data-id="element-272">
          {results.map((result, index) => <div key={index} className="bg-gray-800 rounded-2xl overflow-hidden border-2 border-gray-700 hover:border-green-500 transition-colors duration-300" data-id="element-273">
              <div className="p-4 text-center" data-id="element-274">
                <span className="text-sm font-bold text-green-400 tracking-widest" data-id="element-275">
                  {result.label}
                </span>
              </div>
              <div className="px-4" data-id="element-276">
                <img src={result.image} alt={`${result.label} - Resultados de ventas`} className="w-full rounded-lg" data-id="element-277" />
              </div>
              <div className="p-6 text-center" data-id="element-278">
                <p className="text-3xl md:text-4xl font-black text-green-400 mb-1" data-id="element-279">
                  {result.amount}
                </p>
                <p className="text-gray-400 font-semibold text-sm" data-id="element-280">
                  PESOS ARGENTINOS EN VENTAS
                </p>
              </div>
            </div>)}
        </div>

        <div className="text-center" data-id="element-281">
          <p className="text-2xl md:text-3xl font-black text-white mb-8" data-id="element-282">
            Te enseñamos a tener{' '}
            <span className="text-green-400" data-id="element-283">estos resultados</span>
          </p>
          <CTAButton text="QUIERO EMPEZAR AHORA" onClick={scrollToCompra} size="large" className="animate-pulse-green" data-id="element-284" />
        </div>
      </div>
    </section>;
}